import {Component, Input} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'ui-form-error',
  templateUrl: './form-error.component.html',
  styleUrl: './form-error.component.scss'
})
export class FormErrorComponent {
  @Input() public form! : FormGroup;
  @Input() public key! : string;
  @Input() public name! : string;
}
